import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import ItemModify from '../../Form/ItemModify';

@inject('inventoryItemStore', 'inventoryProductStore', 'inventorySupplierStore', 'stationStore')
@observer
class StationInventoryItemModify extends Component {

  render() {
    const { stationStore, inventoryItemStore, inventoryProductStore, inventorySupplierStore, params: { id, itemId } } = this.props;

    return <ItemModify
      id={itemId}
      title='Inventory Item'
      slug={`/station/${id}/inventory`}
      store={inventoryItemStore}
      itemFields={[
        { label: 'Id', key: 'id', readOnly: true, editOnly: true },
        { label: 'Serial No', key: 'serial_no' },
        { label: 'Product', key: 'product_id', type: 'select', options: inventoryProductStore.items, fields: { value: 'id', label: 'name' } },
        { label: 'Purchase Date', key: 'purchase_date', type: 'date' },
        { label: 'Warranty Date', key: 'warranty_date', type: 'date' },
        { label: 'Calibration Date', key: 'calibration_date', type: 'date' },
        { label: 'Next Calibration Date', key: 'next_calibration_date', type: 'date' },
        { label: 'Installation Date', key: 'installation_date', type: 'date' },
        { label: 'Station', key: 'station_id', type: 'select', options: stationStore.items, fields: { value: 'id', label: 'name' } },
        { label: 'Present Location', key: 'present_location' },
        { label: 'Supplier', key: 'supplier_id', type: 'select', options: inventorySupplierStore.items, fields: { value: 'id', label: 'name' } },
      ]}
      onSave={() => this.props.fetchStationItems()}
    />
  }
}

export default StationInventoryItemModify;



// WEBPACK FOOTER //
// ./src/components/Station/Inventory/StationInventoryModify.js